module.exports = __webpack_public_path__ + "static/media/sc_13_i.623ece2e.png";